module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_05.dot-75d42e91f0422816713205c0ca558ba7.svg";